import React from 'react';

import { Box, CircularProgress } from '@mui/material';

import images from '../assets/images/datalive_logo_color_large.png';

export const CoverProgressLoading = () => {
    const header = document.getElementsByTagName('header');
    const headerHight = header[0] ? header[0].offsetHeight : 0;

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: 9000,
                width: '100vw',
                height: '100vh',
                backgroundColor: '#fff',
            }}
        >
            <Box
                sx={{
                    backgroundColor: '#fff',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    position: 'relative',
                    top: '40%',
                    height: '100%',
                    width: '100%',
                }}
            >
                <CircularProgress
                    color='primary'
                    size={50}
                    sx={{ marginTop: `-${headerHight}px`, margin: '15px' }}
                    thickness={4}
                />
                <img src={images} alt='データライブ社ロゴマーク' width='200px' height='auto' />
            </Box>
        </Box>
    );
};
